import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useConversationStore = defineStore('conversation', () => {
  // 全部会话列表（TIM SDK + 后端合并）
  const allConversation = ref([])
  // 当前会话 ID
  const currentConversationID = ref('')
  // 当前会话 profile
  const currentConversation = ref(null)
  // 当前消息列表
  const currentMessageList = ref([])
  // 分页 cursor
  const nextReqMessageID = ref('')
  const isCompleted = ref(false)
  // TIM 消息是否拉完
  const isCompletedTx = ref(false)
  // 后端分页页码（从1开始）
  const backendPageIndex = ref(0)

  const currentPeerUser = computed(() => {
    if (!currentConversation.value) return null
    return currentConversation.value.userProfile || null
  })

  function setAllConversation(list) {
    allConversation.value = list
  }

  function updateConversation(conv) {
    const idx = allConversation.value.findIndex(
      (c) => c.conversationID === conv.conversationID
    )
    if (idx >= 0) {
      allConversation.value.splice(idx, 1, conv)
    } else {
      allConversation.value.unshift(conv)
    }
    // 按 lastMessage.lastTime 排序
    allConversation.value.sort(
      (a, b) => (b.lastMessage?.lastTime || 0) - (a.lastMessage?.lastTime || 0)
    )
  }

  function setCurrentConversation(conv) {
    currentConversation.value = conv
    currentConversationID.value = conv?.conversationID || ''
  }

  function setMessageList(list) {
    currentMessageList.value = list
  }

  function prependMessages(list) {
    currentMessageList.value = [...list, ...currentMessageList.value]
  }

  function appendMessage(msg) {
    currentMessageList.value.push(msg)
  }

  function updateMessage(msg) {
    const idx = currentMessageList.value.findIndex((m) => m.ID === msg.ID)
    if (idx >= 0) {
      currentMessageList.value.splice(idx, 1, msg)
    }
  }

  function setNextReqMessageID(id) {
    nextReqMessageID.value = id
  }

  function setIsCompleted(val) {
    isCompleted.value = val
  }

  function setIsCompletedTx(val) {
    isCompletedTx.value = val
  }

  function setBackendPageIndex(val) {
    backendPageIndex.value = val
  }

  function reset() {
    currentConversationID.value = ''
    currentConversation.value = null
    currentMessageList.value = []
    nextReqMessageID.value = ''
    isCompleted.value = false
    isCompletedTx.value = false
    backendPageIndex.value = 0
  }

  return {
    allConversation,
    currentConversationID,
    currentConversation,
    currentMessageList,
    nextReqMessageID,
    isCompleted,
    isCompletedTx,
    backendPageIndex,
    currentPeerUser,
    setAllConversation,
    updateConversation,
    setCurrentConversation,
    setMessageList,
    prependMessages,
    appendMessage,
    updateMessage,
    setNextReqMessageID,
    setIsCompleted,
    setIsCompletedTx,
    setBackendPageIndex,
    reset
  }
})
